import {
  wishlistManagementModalActions,
  WishlistManagementModal as WishlistManagementModalComponent,
  wishlistSnackbarActions,
  WishlistSnackbarType,
} from "halifax";
import React from "react";
import { WishlistManagementModalConnectorProps } from "./container";
import { RouterProps } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

export interface WishlistManagementModalProps
  extends WishlistManagementModalConnectorProps,
    RouterProps {}

export const WishlistManagementModal = ({
  fromDate,
  untilDate,
  adultsCount,
  childrenCount,
  searchedPetsCount,
}: WishlistManagementModalProps) => {
  const dispatch = useDispatch();

  const { isOpen, listingId } = useSelector(
    (state: any) => state.wishlistManagementModal
  );

  const onClose = () => {
    dispatch(wishlistManagementModalActions.closeModal());
  };

  const showSnackbar = () => {
    dispatch(
      wishlistSnackbarActions.showSnackbar({
        type: WishlistSnackbarType.ADD,
        wishlistId: "", // TODO: Needs backend update
        listingId: listingId,
      })
    );
    onClose();
  };

  return (
    <WishlistManagementModalComponent
      isOpen={isOpen}
      selectedListingId={listingId}
      onAddToWishlist={showSnackbar}
      onClose={onClose}
      stayDates={{ fromDate, untilDate }}
      guests={{
        adults: adultsCount,
        children: childrenCount,
        pets: searchedPetsCount,
      }}
    />
  );
};
